import React from "react";

export default function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}) {
  return (
    <div className="min-h-[calc(100vh-120px)] flex items-center justify-center px-4 py-10 bg-gradient-to-br from-slate-50 via-white to-indigo-50">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-10 h-40 w-40 rounded-full bg-indigo-200/30 blur-3xl" />
        <div className="absolute bottom-10 right-10 h-40 w-40 rounded-full bg-cyan-200/30 blur-3xl" />
      </div>

      <div className="relative w-full max-w-md">
        <div className="rounded-3xl border border-white/70 bg-white/80 backdrop-blur-xl shadow-[0_20px_80px_rgba(15,23,42,0.12)] p-8">
          <div className="mb-8 text-center">
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-600 to-cyan-500 text-white font-bold shadow-lg">
              AR
            </div>
            <h1 className="text-3xl font-bold tracking-tight text-slate-900">
              {title}
            </h1>
            <p className="mt-2 text-sm text-slate-500">{subtitle}</p>
          </div>

          {children}

          {footer ? (
            <div className="mt-6 border-t border-slate-200 pt-5 text-center text-sm text-slate-500">
              {footer}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}